;(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	const initProductMediaArrows = () => {
		const mediaListWrapper = document.querySelector('.product__media-list-wrapper')
		if (!mediaListWrapper) return

		const arrowLeft = mediaListWrapper.querySelector('.product__media-arrow--left')
		const arrowRight = mediaListWrapper.querySelector('.product__media-arrow--right')
		const mediaList = mediaListWrapper.querySelector('.js-media-list')

		if (!arrowLeft || !arrowRight || !mediaList) return

		// 等待 Swiper 初始化
		const checkSwiper = setInterval(() => {
			if (mediaList.swiper) {
				clearInterval(checkSwiper)
				const swiper = mediaList.swiper

				// 更新箭头状态
				const updateArrowStates = () => {
					if (swiper.isBeginning) {
						arrowLeft.disabled = true
						arrowLeft.classList.add('disabled')
					} else {
						arrowLeft.disabled = false
						arrowLeft.classList.remove('disabled')
					}

					if (swiper.isEnd) {
						arrowRight.disabled = true
						arrowRight.classList.add('disabled')
					} else {
						arrowRight.disabled = false
						arrowRight.classList.remove('disabled')
					}
				}

				// 初始状态
				updateArrowStates()

				// 监听滑动事件
				swiper.on('slideChange', updateArrowStates)
				swiper.on('reachBeginning', updateArrowStates)
				swiper.on('reachEnd', updateArrowStates)

				// 点击事件 - 完全阻止事件传播
				const handleArrowClick = (e, isLeft) => {
					// 立即阻止所有事件传播
					e.stopImmediatePropagation()
					e.stopPropagation()
					e.preventDefault()
					
					// 检查是否禁用
					if ((isLeft && swiper.isBeginning) || (!isLeft && swiper.isEnd)) {
						return false
					}

					// 执行滑动
					if (isLeft) {
						swiper.slidePrev()
					} else {
						swiper.slideNext()
					}
					
					return false
				}

				arrowLeft.addEventListener('click', (e) => handleArrowClick(e, true), { capture: true })
				arrowRight.addEventListener('click', (e) => handleArrowClick(e, false), { capture: true })
			}
		}, 100)

		// 超时清理
		setTimeout(() => {
			clearInterval(checkSwiper)
		}, 5000)
	}

	const initPopupSliderArrows = () => {
		const popupSlider = document.querySelector('.js-popup-slider')
		if (!popupSlider) return

		const prevButton = document.querySelector('.product-media-modal .swiper-button-prev')
		const nextButton = document.querySelector('.product-media-modal .swiper-button-next')

		if (!prevButton || !nextButton) return

		// 等待 Swiper 初始化
		const checkSwiper = setInterval(() => {
			if (popupSlider.swiper) {
				clearInterval(checkSwiper)
				const swiper = popupSlider.swiper

				// 更新箭头状态
				const updateArrowStates = () => {
					if (swiper.isBeginning) {
						prevButton.classList.add('swiper-button-disabled')
						prevButton.setAttribute('aria-disabled', 'true')
					} else {
						prevButton.classList.remove('swiper-button-disabled')
						prevButton.setAttribute('aria-disabled', 'false')
					}

					if (swiper.isEnd) {
						nextButton.classList.add('swiper-button-disabled')
						nextButton.setAttribute('aria-disabled', 'true')
					} else {
						nextButton.classList.remove('swiper-button-disabled')
						nextButton.setAttribute('aria-disabled', 'false')
					}
				}

				// 初始状态
				updateArrowStates()

				// 监听滑动事件
				swiper.on('slideChange', updateArrowStates)
				swiper.on('reachBeginning', updateArrowStates)
				swiper.on('reachEnd', updateArrowStates)

				// 点击事件 - 如果按钮被禁用，阻止默认行为
				prevButton.addEventListener('click', (e) => {
					if (swiper.isBeginning) {
						e.preventDefault()
						e.stopPropagation()
						return false
					}
				})

				nextButton.addEventListener('click', (e) => {
					if (swiper.isEnd) {
						e.preventDefault()
						e.stopPropagation()
						return false
					}
				})
			}
		}, 100)

		// 超时清理
		setTimeout(() => {
			clearInterval(checkSwiper)
		}, 5000)
	}

	const initMainImageClickArea = () => {
		// 检测是否为移动端（窗口宽度小于 768px）
		const isMobile = () => window.innerWidth < 768
		
		// 找到所有主图的 modal-opener 元素
		const modalOpeners = document.querySelectorAll('.product__modal-opener--image')
		
		modalOpeners.forEach((modalOpener) => {
			const button = modalOpener.querySelector('.product__media-toggle')
			if (!button) return
			
			// 拦截按钮的点击事件
			button.addEventListener('click', (e) => {
				// 移动端不应用限制，保持原有行为
				if (isMobile()) {
					return
				}
				
				// 获取图片元素（在 .product__media 内）
				const mediaContainer = modalOpener.querySelector('.product__media')
				if (!mediaContainer) return
				
				const img = mediaContainer.querySelector('img')
				if (!img) return
				
				// 获取图片的位置和尺寸
				const imgRect = img.getBoundingClientRect()
				const clickX = e.clientX - imgRect.left
				const imgWidth = imgRect.width
				
				// 计算中心50%区域的边界
				// 中心50% = 从25%到75%的位置
				const centerStart = imgWidth * 0.25
				const centerEnd = imgWidth * 0.75
				
				// 如果点击不在中心50%区域，阻止打开模态框
				if (clickX < centerStart || clickX > centerEnd) {
					e.preventDefault()
					e.stopPropagation()
					e.stopImmediatePropagation()
					return false
				}
			}, true) // 使用捕获阶段，确保在其他监听器之前执行
		})
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			'.product-media-modal__content'
		)
		const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || []

		images.forEach((el) => {
			el.addEventListener('click', (e) => {
				const popupSlider = document.querySelector('.js-popup-slider')
				if (popupSlider?.swiper) {
					const swiper = popupSlider.swiper
					
					// PC端：检查点击是否发生在禁用的导航按钮区域内
					if (window.innerWidth >= 768) {
						const prevButton = document.querySelector('.product-media-modal .swiper-button-prev')
						const nextButton = document.querySelector('.product-media-modal .swiper-button-next')
						
						// 检查点击位置是否在按钮区域内
						if (prevButton && swiper.isBeginning) {
							const buttonRect = prevButton.getBoundingClientRect()
							if (e.clientX >= buttonRect.left && e.clientX <= buttonRect.right &&
								e.clientY >= buttonRect.top && e.clientY <= buttonRect.bottom) {
								return
							}
						}
						
						if (nextButton && swiper.isEnd) {
							const buttonRect = nextButton.getBoundingClientRect()
							if (e.clientX >= buttonRect.left && e.clientX <= buttonRect.right &&
								e.clientY >= buttonRect.top && e.clientY <= buttonRect.bottom) {
								return
							}
						}
					}
					
					// 移动端：当轮播在最左/最右且点击发生在图片边缘区域时，不触发放大
					if (window.innerWidth < 768) {
						const rect = el.getBoundingClientRect()
						const clickX = e.clientX - rect.left
						const edgeThreshold = rect.width * 0.2 // 左右各 20% 认为是"边缘"

						const isAtBeginningEdge =
							swiper.isBeginning && clickX <= edgeThreshold
						const isAtEndEdge =
							swiper.isEnd && clickX >= rect.width - edgeThreshold

						if (isAtBeginningEdge || isAtEndEdge) {
							return
						}
					}
				}
				imagesWrapper.classList.toggle('zoom')
			})
		})
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	//document.addEventListener('scroll', () => {
	//	const navigation = document.querySelector('.product__media_navigation')
	//	if (navigation) {
	//		const footer = document.querySelector('.footer')
	//		const navigationHeight = navigation.offsetHeight
	//		const screen = window.scrollY
	//		const overview = document.querySelector('#overview').scrollTop
	//		const overviewBottom =
	//			document.querySelector('#overview').clientHeight + overview
	//		if (screen >= overview && screen <= overviewBottom) {
	//			document.querySelector('#overview-link').classList.add('active')
	//		} else {
	//			document.querySelector('#overview-link').classList.remove('active')
	//		}
	//		if (window.innerHeight + screen - navigationHeight > footer.offsetTop) {
	//			navigation.style.opacity = '0'
	//			navigation.style.visibility = 'hidden'
	//		} else {
	//			navigation.style.opacity = '1'
	//			navigation.style.visibility = 'visible'
	//		}
	//	}
	//})

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) {
			navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'
		}
		document.addEventListener('scroll', () => {
			if (navigation) {
				navigation.classList.add('show-navigation')
			}
			if (navigation) {
				const footer = document.querySelector('.footer')
				const navigationHeight = navigation.offsetHeight
				const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
				const screen = window.scrollY
				sections.forEach((section, i) => {
					if (section) {
						const em = document.querySelector(`${section.sectionSelector}`)
						if (em) {
							const rect = em.getBoundingClientRect()	
							if (rect.top <= 1 && rect.top > rect.height * -1) {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.add('active')
							} else {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.remove('active')
							}
							document.querySelector(`${section.linkSelector}`).addEventListener('click', () => {
								em.scrollIntoView({ behavior: 'smooth' });
							})
						} else {
							document.querySelector(`${section.linkSelector}`).style.display = 'none';
						}
					}
				})
				
				const rect = secondSection.getBoundingClientRect();
				const isSecondSectionScrolled = rect.top < 0;
				// const isNearFooter = window.innerHeight + screen - navigationHeight > footer.offsetTop;
				const footerOffsetTop = footer ? footer.offsetTop : document.body.scrollHeight;
				const isNearFooter = window.innerHeight + screen - navigationHeight > footerOffsetTop;


				navigation.style.transform = isSecondSectionScrolled && !isNearFooter
				? 'translateX(-50%) translateY(0)'
				: 'translateX(-50%) translateY(calc(100% + 16px))';
			}
		})
	}

	// 存储模态框中最后查看的图片索引
	let lastViewedModalIndex = null

	// 禁用主图 Swiper 的触摸滑动功能（模态框打开时调用）
	const disableMainImageSwiperTouch = () => {
		const mediaList = document.querySelector('.js-media-list')
		if (!mediaList || !mediaList.swiper) {
			return
		}
		
		const swiper = mediaList.swiper
		
		// 禁用触摸滑动
		if (swiper.params) {
			swiper.params.allowTouchMove = false
			swiper.params.noSwiping = true
		}
		swiper.allowTouchMove = false
		swiper.disable()
	}

	// 恢复主图 Swiper 的触摸滑动功能，并跳转到模态框中最后查看的图片
	const restoreMainImageSwiperTouch = () => {
		const mediaList = document.querySelector('.js-media-list')
		if (!mediaList || !mediaList.swiper) {
			return
		}
		
		const swiper = mediaList.swiper
		
		// 先禁用再启用，强制重新绑定所有事件监听器
		swiper.disable()
		
		// 确保触摸事件被启用 - 设置参数
		if (swiper.params) {
			swiper.params.allowTouchMove = true
			swiper.params.noSwiping = false
			swiper.params.simulateTouch = true
		}
		
		// 直接设置 Swiper 实例的属性（这些属性会覆盖 params）
		swiper.allowTouchMove = true
		swiper.allowSlideNext = true
		swiper.allowSlidePrev = true
		
		// 重置触摸状态，清除任何残留的触摸状态
		if (swiper.touchEventsData) {
			swiper.touchEventsData.isTouched = false
			swiper.touchEventsData.isMoved = false
			swiper.touchEventsData.isTouching = false
			swiper.touchEventsData.touches = {}
			swiper.touchEventsData.touchesCurrent = {}
			swiper.touchEventsData.touchesStart = {}
		}
		
		// 重新启用 Swiper（这会重新绑定所有事件监听器，包括触摸事件）
		swiper.enable()
		
		// 如果模态框中最后查看的图片索引存在，跳转到该索引
		if (lastViewedModalIndex !== null && lastViewedModalIndex >= 0) {
			// 确保索引在有效范围内
			const maxIndex = swiper.slides.length - 1
			const targetIndex = Math.min(lastViewedModalIndex, maxIndex)
			swiper.slideTo(targetIndex, 0) // 使用 0 速度，立即跳转
		}
		
		// 更新 Swiper 以确保所有设置生效
		swiper.update()
		if (typeof swiper.updateSlidesClasses === 'function') {
			swiper.updateSlidesClasses()
		}
		
		// 强制重新计算尺寸和幻灯片
		if (typeof swiper.updateSize === 'function') {
			swiper.updateSize()
		}
		if (typeof swiper.updateSlides === 'function') {
			swiper.updateSlides()
		}
		
		// 在移动端，延迟一下再更新，确保触摸事件被正确恢复
		if (window.innerWidth < 768) {
			setTimeout(() => {
				swiper.update()
				// 再次确保触摸事件被启用
				swiper.allowTouchMove = true
				if (swiper.params) {
					swiper.params.allowTouchMove = true
					swiper.params.noSwiping = false
				}
			}, 50)
		}
	}

	// 监听模态框 Swiper 的滑动事件，记录最后查看的图片索引
	const trackModalSliderIndex = () => {
		const popupSlider = document.querySelector('.js-popup-slider')
		if (!popupSlider) return

		// 等待 Swiper 初始化
		const checkSwiper = setInterval(() => {
			if (popupSlider.swiper) {
				clearInterval(checkSwiper)
				const swiper = popupSlider.swiper

				// 记录当前索引（模态框打开时的初始索引）
				lastViewedModalIndex = swiper.activeIndex

				// 监听滑动事件，更新最后查看的索引
				swiper.on('slideChange', () => {
					lastViewedModalIndex = swiper.activeIndex
				})
			}
		}, 100)

		// 超时清理
		setTimeout(() => {
			clearInterval(checkSwiper)
		}, 5000)
	}

	// 监听模态框打开事件，重新初始化按钮状态
	const observeModalOpen = () => {
		const productModal = document.querySelector('product-modal')
		if (productModal) {
			// 使用 MutationObserver 监听 open 属性的变化
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
						if (productModal.hasAttribute('open')) {
							// 模态框打开时，记录主图 Swiper 的当前索引并禁用主图滑动
							const mediaList = document.querySelector('.js-media-list')
							if (mediaList && mediaList.swiper) {
								lastViewedModalIndex = mediaList.swiper.activeIndex
								// 禁用主图滑动，避免与模态框滑动冲突
								disableMainImageSwiperTouch()
							}

							// 延迟初始化按钮状态和跟踪模态框滑动
							setTimeout(() => {
								initPopupSliderArrows()
								trackModalSliderIndex()
							}, 100)
						} else {
							// 模态框关闭时，恢复主图的触摸滑动功能并跳转到最后查看的图片
							// 等待 body 的 overflow-hidden-modal 类被移除后再恢复
							// 使用 requestAnimationFrame 确保 DOM 更新完成
							requestAnimationFrame(() => {
								setTimeout(() => {
									// 确保 body 的 overflow-hidden-modal 类已被移除
									if (!document.body.classList.contains('overflow-hidden-modal')) {
										restoreMainImageSwiperTouch()
									} else {
										// 如果类还在，再等待一下
										setTimeout(() => {
											restoreMainImageSwiperTouch()
										}, 100)
									}
								}, 100)
							})
						}
					}
				})
			})
			observer.observe(productModal, {
				attributes: true,
				attributeFilter: ['open']
			})
		}
	}
	
	// 页面加载时观察模态框
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observeModalOpen)
	} else {
		observeModalOpen()
	}

	// 同时监听 modalClosed 事件，确保模态框关闭后恢复触摸功能并跳转到最后查看的图片
	document.body.addEventListener('modalClosed', () => {
		// 等待 body 的 overflow-hidden-modal 类被移除后再恢复
		// 使用 requestAnimationFrame 确保 DOM 更新完成
		requestAnimationFrame(() => {
			setTimeout(() => {
				// 确保 body 的 overflow-hidden-modal 类已被移除
				if (!document.body.classList.contains('overflow-hidden-modal')) {
					restoreMainImageSwiperTouch()
				} else {
					// 如果类还在，再等待一下
					setTimeout(() => {
						restoreMainImageSwiperTouch()
					}, 100)
				}
			}, 100)
		})
	})


	/**
	 * 断开label for 关联，禁止触发options
	 */
	const initVariantOptionsCtrl = () => {
		const disabledElement = document.querySelectorAll('variant-radios input.disabled');
		disabledElement.forEach(item => {
			item.id = '';
		});
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
		initProductMediaArrows()
		initPopupSliderArrows()
		initMainImageClickArea()
		initVariantOptionsCtrl()
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
	initProductMediaArrows()
	initPopupSliderArrows()
	initMainImageClickArea()
	initVariantOptionsCtrl()
})()
